import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { setAdminUser, AUTH_ERROR_KEY } from './AdminGate';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Exchanges the Google session_id (URL fragment) for a session cookie, then returns to the same admin page.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    const back = location.pathname.startsWith('/admin') ? location.pathname : '/admin/chats';
    fetch(`${API}/auth/session`, { method: 'POST', credentials: 'include', headers: { 'X-Session-ID': sessionId } })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.detail || 'Sign-in failed. Please try again.');
        setAdminUser(data);
        navigate(back, { replace: true, state: { adminUser: data } });
      })
      .catch((e) => {
        sessionStorage.setItem(AUTH_ERROR_KEY, e.message);
        navigate(back, { replace: true });
      });
  }, [location, navigate]);

  return <main className="min-h-screen bg-splash-cream grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-splash-teal" /></main>;
}
